// @flow
import React from 'react'
import styled from 'styled-components'

type Props = {
  active?: boolean,
  onClick?: () => mixed,
  icon: 'MOBILE_M'|'MOBILE_L'|'TABLET'|'LAPTOP'|'LAPTOP_L'|'LAPTOP_XL'|'COMPONENTS'|'CONFIG'|'FULLSCREEN'
}

export default class Icon extends React.Component<Props> {

  static defaultProps = {
    active: false,
    onClick: () => null
  }

  getClass = () => {
    switch(this.props.icon){
      case 'MOBILE_M':   return 'fa fa-mobile'
      case 'MOBILE_L':   return 'fa fa-mobile'
      case 'TABLET':     return 'fa fa-tablet'
      case 'LAPTOP':     return 'fa fa-desktop'
      case 'LAPTOP_L':   return 'fa fa-desktop'
      case 'LAPTOP_XL':  return 'fa fa-desktop'
      case 'COMPONENTS': return 'fa fa-list-ul'
      case 'CONFIG':     return 'fa fa-cog'
      case 'FULLSCREEN': return 'fa fa-arrows-alt'
      case 'BACK':       return 'fa fa-chevron-left'
      default: return ''
    }
  }

  renderLabel = (txt:*, mrg:*) => {
    return (
      <LabelWrapper mrg={mrg}>
        <div>{txt}</div>
      </LabelWrapper>
    )
  }

  render(){
    let {icon, active, onClick} = this.props
    return (
      <Wrapper className={this.getClass()} active={active} onClick={onClick}>
        {icon === 'LAPTOP_L' && this.renderLabel('L', -10)}
        {icon === 'LAPTOP_XL' && this.renderLabel('XL', -10)}
        {icon === 'MOBILE_L' && this.renderLabel('L',0)}
      </Wrapper>
    )
  }
}

const Wrapper = styled.i`
  font-size: 30px;
  padding: 5px;
  margin: 0 10px;
  cursor: pointer;
  color: ${props => props.active ? '#009688' : 'whitesmoke'};
  display: inline-block;
  position: relative;
`

const LabelWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  > div {
    margin-top: ${props => props.mrg}px;
    color: #ffeb3b;
  }
`


// WEBPACK FOOTER //
// ./src/components/Icon.js